export default __webpack_public_path__ + "static/trees-dd079822e20e6ac291ada4152b27cf77.png";